import { Logger } from '@/classes/Logger';
import { DocumentService } from '@/services/DocumentService';
import { DocumentPagePreferencesModel, RootState, ThumbnailMutationTypes, ThumbnailSearchModel, ThumbnailState, ThumbnailViewModel } from '@/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<ThumbnailState, RootState> = {
  setThumbnail({ commit }, payload: ThumbnailSearchModel) {
    commit(ThumbnailMutationTypes.AddThumbnail, payload as ThumbnailViewModel);
    DocumentService.getThumbnailAsync(payload).then(
      (response) => {
        const thumbnail: ThumbnailViewModel = { ...payload, ...response, documentPagePreference : {} as DocumentPagePreferencesModel };
        commit(ThumbnailMutationTypes.AddThumbnail, thumbnail);
      },
      (error) => {
        Logger.$log(error);
      }
    );
  },
  removeThumbnailPagesForDocument({ commit }, { documentId, pages }) {
    commit(ThumbnailMutationTypes.RemoveThumbnailPagesForDocument, { documentId, pages });
  },
  clearThumbnailCacheForDocument({ commit }, { documentId }) {
    if (documentId) {
      commit(ThumbnailMutationTypes.ClearThumbnailCacheForDocument, { documentId });
    }
  }
};
